/**
 * Centralized Chart.js configuration
 * 
 * Instead of registering all chart types with `Chart.register(...registerables)`,
 * we only register the specific components needed by this application.
 * This reduces the bundle size by excluding unused chart types and plugins.
 * 
 * Used chart types in this application:
 * - Line charts (most common)
 * - Bar charts
 * - Doughnut charts
 */
import {
  Chart,
  // Chart types
  LineController,
  BarController,
  DoughnutController,
  // Elements
  LineElement,
  PointElement,
  BarElement,
  ArcElement,
  // Scales
  CategoryScale,
  LinearScale,
  LogarithmicScale,
  // Plugins
  Legend,
  Tooltip,
  Title,
  Filler,
  ScatterController
} from 'chart.js';
import annotationPlugin from 'chartjs-plugin-annotation';

// Register only the components we need
Chart.register(
  // Controllers for chart types
  LineController,
  BarController,
  DoughnutController,
  // Visual elements
  LineElement,
  PointElement,
  BarElement,
  ArcElement,
  ScatterController,
  // Scales
  CategoryScale,
  LinearScale,
  LogarithmicScale,
  // Plugins
  Legend,
  Tooltip,
  Title,
  Filler,
  annotationPlugin
);

// Export Chart for use in components
export { Chart };

// Re-export commonly used types
export type { ChartConfiguration, ChartType, ChartData, ChartOptions } from 'chart.js';
